function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M130 0H30A30 30 0 0 0 0 30v99.8a30 30 0 0 0 30 30h100a30 30 0 0 0 30-30V30a30 30 0 0 0-30-30Z",
  fill: "#8DE1FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 151.7a30 30 0 0 0 18 8.3h105.7c2.7-.3 5.3-.9 7.7-1.8-7.2-17-19.4-32.8-37.7-32.6l-63.5 12.2a46.3 46.3 0 0 0-30.2 13.9Z",
  fill: "#1A4E99"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M135 65.7c-.4-.2-.3-.7 0-.8a15.8 15.8 0 1 0-8.9-30 .4.4 0 0 1-.5-.5 15.8 15.8 0 0 0-26.2-16.1c-.3.2-.7 0-.7-.3a15.8 15.8 0 0 0-30.9-4.7c-.1.4-.5.4-.7.1A15.8 15.8 0 0 0 39.6 29c.1.3-.1.6-.4.5A15.8 15.8 0 0 0 26.6 57c.2.3.1.7-.2.8A15.8 15.8 0 0 0 30.2 89c.3 0 .5.3.4.6A15.8 15.8 0 0 0 55 109.2c.2-.2.6 0 .7.2a15.8 15.8 0 0 0 27.9 5.1c.1-.2.3-.2.5 0a15.7 15.7 0 0 0 19-.2h.6a15.7 15.7 0 0 0 24.8-17.6c-.1-.2 0-.5.4-.5h.5a15.8 15.8 0 0 0 5.6-30.5Z",
  fill: "#1F75DB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M90.8 56.7H64.4v13.9c0 .5-.6.8-1 .4a7.6 7.6 0 1 0-5.2 13.2h5.9c.2 0 .3.2.3.3V130.2c.7 5.5 4.8 9.7 9.8 9.7 5.4 0 9.8-5 9.8-11v-12.2c2.2.6 4.4 1 6.8 1h1.5c13.7 0 24.8-11.2 24.8-24.8V56.7H90.8Z",
  fill: "#0E3163"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M103.5 80c-.5 0-1-.1-1.5-.4a.5.5 0 1 1 .5-.9c1 .6 2.4.2 3-.9.6-1 .2-2.4-.9-3l-2.4-1.2a.5.5 0 1 1 .5-.9l2.4 1.2a3.2 3.2 0 0 1 1.3 4.4 3.2 3.2 0 0 1-2.9 1.7ZM101.9 87a22 22 0 0 1-11.3-2.9.5.5 0 1 1 .6-.8c2.4 1.9 10.7 3.7 14.5 2.1.3 0 .6 0 .7.3.1.3 0 .6-.3.7-1.1.4-2.6.7-4.2.7Z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M137 46.5c-3.6 0-16.8-8-16.8-18.8 0-5.3 4-11 10.2-11a9 9 0 0 1 6.5 2.7 9 9 0 0 1 6.6-2.7c6 0 10.1 5.7 10.1 11 0 10.8-13.2 18.8-16.7 18.8ZM36.4 136.6c-3.5 0-16.7-8-16.7-19 0-5.2 4.1-10.9 10.2-10.9a9 9 0 0 1 6.5 2.7 9 9 0 0 1 6.6-2.7c6 0 10.1 5.7 10.1 11 0 10.8-13.2 18.9-16.7 18.9ZM35.9 65.6C30 65.6 8.3 52.3 8.3 34.5c0-8.7 6.8-18 16.8-18 5 0 8.6 2.2 10.8 4.4a15 15 0 0 1 10.8-4.5c10 0 16.7 9.3 16.7 18 0 18-21.8 31.2-27.5 31.2ZM131.6 146.9c-4.5 0-21.6-10.4-21.6-24.5 0-6.9 5.2-14.2 13.1-14.2 4 0 6.8 1.8 8.5 3.5 1.8-1.7 4.5-3.5 8.5-3.5 7.9 0 13.2 7.3 13.2 14.2 0 14-17.2 24.5-21.7 24.5Z",
  fill: "#D04D7C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M103.2 71.2a.5.5 0 0 1-.5-.5 3.8 3.8 0 0 1 3.8-4h6.3c1-.1 2 .3 2.8 1 .7.7 1.1 1.7 1.2 2.7 0 .3-.3.5-.6.5a.5.5 0 0 1-.5-.5 2.8 2.8 0 0 0-2.9-2.8l-6.3.2a2.8 2.8 0 0 0-2.8 2.8c0 .3-.2.6-.5.6ZM83.9 70.7a.5.5 0 0 1-.6-.5c0-2 1.7-3.8 3.8-3.9h5.1c1-.1 2 .3 2.8 1 .7.7 1.2 1.7 1.2 2.7 0 .3-.2.5-.5.5a.5.5 0 0 1-.6-.5 2.8 2.8 0 0 0-2.8-2.8l-5.2.1a2.8 2.8 0 0 0-2.7 3c0 .2-.3.4-.5.4Z",
  fill: "#fff"
});

function SvgThankyouIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 160,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = React.forwardRef(SvgThankyouIcon);
export default __webpack_public_path__ + "static/media/thankyou-icon.34bbef61.svg";
export { ForwardRef as ReactComponent };